import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "./Context/AuthContext";
import { SuspenseLoader } from "./Layout/Common/loader";
import SuspenseComponentLoader from "./Context/SuspenseLoader";
import SessionTimeoutProvider from "./Context/sessionTimeoutProvider";

const CheckRoute = ({ Component, redirectIfAuthenticated = false, sessionGuardWhenAuthenticated = false }) => {
  const { postAuthentication, authLoading, isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth({ isRedirect: true });
  }, [Component, redirectIfAuthenticated]);

  const checkAuth = async ({ isRedirect = false }) => {
    setLoading(true);
    var response = await postAuthentication();
    if (response) {
      if (isRedirect && redirectIfAuthenticated) {
        window.location.replace("/home");
        return;
      }
      setLoading(false);
      return;
    }

    setLoading(false);
  };
  if (authLoading) {
    return <SuspenseComponentLoader />;
  }

  const content = (
    <Fragment>
      <SuspenseLoader show={loading} />
      <div style={{ visibility: loading ? "hidden" : "" }}>
        <Component />
      </div>
    </Fragment>
  );

  // On opt-in public routes (e.g. pay-account), a logged-in user gets the same idle-timeout +
  // "Session Expired" popup as protected pages. Guests (isAuthenticated === false) are unaffected.
  return sessionGuardWhenAuthenticated && isAuthenticated ? (
    <SessionTimeoutProvider>{content}</SessionTimeoutProvider>
  ) : (
    content
  );
};

export default CheckRoute;
